import { useState, useEffect, useRef } from 'react';

function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);
  const mediaQueryRef = useRef<MediaQueryList | null>(null); // Store the media query object with null as initial value

  useEffect(() => {
    if (!mediaQueryRef.current) {
      mediaQueryRef.current = window.matchMedia(query);
      setMatches(mediaQueryRef.current.matches); // Initial match state
    }

    const handleChange = () => setMatches(mediaQueryRef.current!.matches); // Use non-null assertion after initialization

    mediaQueryRef.current.addEventListener('change', handleChange);

    return () => {
      mediaQueryRef.current!.removeEventListener('change', handleChange); // Use non-null assertion after initialization
    };
  }, [query]); // Re-run on query change

  return matches;
}

export default useMediaQuery;
